import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-link-invalid',
  templateUrl: './link-invalid.component.html',
  styleUrls: ['./link-invalid.component.scss']
})
export class LinkInvalidComponent {

  constructor(private router: Router) {}

  goHome() {
    this.router.navigate(['/']);
  }
}
